import React from "react"
import ReactDOM from "react-dom"
import Dogapp from "./Dogapp"
import "./app.css"

ReactDOM.render(<Dogapp />,document.getElementById("root"))
